import { createTheme } from "@mui/material";
import { default as ColorPalette } from "./Colors";

const Theme = createTheme({
  palette: ColorPalette,
  typography: {
    fontFamily: ["Lexend", "Inter", "sans-serif"].join(","),
  },
});

export default Theme;
